/**
 * 主题色
 */
export const PRIMARY_COLOR = '#00a0ff';
